import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GetStarted from './pages/auth/GetStarted';
import Login from './pages/auth/Login';
import SignUp from './pages/auth/SignUp';
import CustomerDashboard from './pages/dashboard/CustomerDashboard';
import TripTracking from './pages/TripTracking';
import VerifyReceipt from './pages/VerifyReceipt';
import Terms from './pages/legal/Terms';
import GuestRoute from './components/auth/GuestRoute';
import ProtectedRoute from './components/auth/ProtectedRoute';
import OfflineOverlay from './components/OfflineOverlay';

const App: React.FC = () => (
  <Router>
    <OfflineOverlay />
    <Routes>
      <Route path="/" element={<GuestRoute><GetStarted /></GuestRoute>} />
      <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
      <Route path="/signup" element={<GuestRoute><SignUp /></GuestRoute>} />
      <Route path="/home" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
      <Route path="/track/:rideId" element={<TripTracking />} />
      <Route path="/verify/:rideId" element={<VerifyReceipt />} />
      {/* Public and unguarded: doubles as the terms URL for the app store listings. */}
      <Route path="/terms" element={<Terms />} />
    </Routes>
  </Router>
);

export default App;
